import React, { useRef, useEffect } from 'react';

export default function Wavelet() {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const dpr = Math.min(2, window.devicePixelRatio || 1);

    let W = 0, H = 0;
    function resize() {
      W = canvas.clientWidth;
      H = canvas.clientHeight;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();

    const ro = new ResizeObserver(resize);
    ro.observe(canvas);

    const t0 = performance.now();
    let raf = 0;
    let lastFrame = 0;

    function draw() {
      const t = (performance.now() - t0) / 1000;
      ctx.clearRect(0, 0, W, H);

      const cx = W / 2;
      const cy = H / 2;
      const sigma = W * 0.18;
      const k = (Math.PI * 2) * 9 / W;
      const amp = Math.min(H * 0.42, 130);
      const phase = t * 0.65;

      const root = getComputedStyle(document.documentElement);
      const fg = root.getPropertyValue('--fg').trim() || '#f8f8f2';

      ctx.beginPath();
      const step = 1.0;
      for (let x = 0; x <= W; x += step) {
        const dx = x - cx;
        const env = Math.exp(-(dx * dx) / (2 * sigma * sigma));
        const y = cy + Math.sin(dx * k + phase) * env * amp;
        if (x === 0) ctx.moveTo(x, y);
        else          ctx.lineTo(x, y);
      }

      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.strokeStyle = fg;
      ctx.lineWidth = Math.max(6, H * 0.045);
      ctx.stroke();

      lastFrame = performance.now();
    }

    function loop() {
      raf = requestAnimationFrame(loop);
      draw();
    }
    loop();

    const fallback = setInterval(() => {
      if (performance.now() - lastFrame > 1000) draw();
    }, 1500);

    return () => {
      cancelAnimationFrame(raf);
      clearInterval(fallback);
      ro.disconnect();
    };
  }, []);

  return <canvas ref={ref} className="wavelet-canvas" aria-hidden="true" />;
}
